var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("FormSubmitPopup", {
        ref: "formPopup",
        attrs: {
          title: _vm.title,
          rightMethod: _vm.onSubmitted,
          rightButtonText: _vm.$t("confirm"),
          hasAlert: "",
          large: ""
        },
        on: {
          popupClose: function($event) {
            return _vm.$emit("input", false)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "align-baseline": "",
                                          "justify-space-between": "",
                                          wrap: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "title",
                                            attrs: { md2: "" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("templateInfo")) +
                                                ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md10: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": "",
                                                  "align-baseline": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md2: "", xs5: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "templateName"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "template"
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.name = $$v
                                                        },
                                                        expression: "name"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md2: "", xs5: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "senderName"
                                                        ),
                                                        rules: [
                                                          _vm.fieldCharLimit(
                                                            "Sender name",
                                                            35
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.from.fullName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "fullName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "from.fullName"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md2: "", xs5: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "companyName"
                                                        )
                                                      },
                                                      model: {
                                                        value: _vm.from.company,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "company",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "from.company"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md2: "", xs5: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "productQty"
                                                        )
                                                      },
                                                      model: {
                                                        value: _vm.quantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.quantity = $$v
                                                        },
                                                        expression: "quantity"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md2: "", xs5: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        rules: [
                                                          _vm.fieldIsNoLessThanZero(
                                                            "maxQuantity"
                                                          ),
                                                          _vm.fieldIsInteger(
                                                            "maxQuantity"
                                                          ),
                                                          function() {
                                                            return _vm.quantityLimit
                                                              ? _vm.quantityLimit >=
                                                                  _vm.quantity ||
                                                                  "Max quantity should be no less than product quantity"
                                                              : true
                                                          }
                                                        ],
                                                        hint: _vm.$t(
                                                          "maxQuantityHint",
                                                          {
                                                            maxQuantity:
                                                              _vm.quantityLimit
                                                          }
                                                        ),
                                                        label: _vm.$t(
                                                          "maxQuantity"
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.quantityLimit,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.quantityLimit = _vm._n(
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "quantityLimit"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-layout",
                                              { attrs: { "align-center": "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md11: "", xs5: "" }
                                                  },
                                                  [
                                                    _c("v-combobox", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: "sku",
                                                        chips: "",
                                                        multiple: "",
                                                        "deletable-chips": "",
                                                        suffix: _vm.sku.length.toString()
                                                      },
                                                      scopedSlots: _vm._u([
                                                        {
                                                          key: "input",
                                                          fn: function(data) {
                                                            return [
                                                              _c(
                                                                "v-chip",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      data.selected,
                                                                    close: ""
                                                                  },
                                                                  on: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeChip(
                                                                        data.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        data.item
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ]),
                                                      model: {
                                                        value: _vm.sku,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.sku = $$v
                                                        },
                                                        expression: "sku"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md1: "", xs5: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticStyle: {
                                                          transform:
                                                            "translateY(7px)"
                                                        },
                                                        attrs: {
                                                          dark: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.showBatchAddSkuDialog.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t("batch")
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%", height: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c("v-layout", { staticClass: "title" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("labelDetails")) +
                                          ":\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("v-data-table", {
                                      staticClass: "elevation-1 mt-2",
                                      attrs: {
                                        headers: _vm.packageHeaders,
                                        items: _vm.packages,
                                        "hide-actions": "",
                                        "item-key": "index"
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "headerCell",
                                          fn: function(props) {
                                            return [
                                              props.header.value === "action"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var on =
                                                                    ref.on
                                                                  return [
                                                                    _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            flat:
                                                                              "",
                                                                            small:
                                                                              "",
                                                                            icon:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click:
                                                                              _vm.addPackage
                                                                          }
                                                                        },
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "add"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "addPackage"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(props.header.text)
                                                    )
                                                  ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  props.index > 0
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            flat: "",
                                                            small: "",
                                                            icon: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removePackage(
                                                                props.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("delete")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      "hide-details": "",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          "weight"
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          "weight"
                                                        )
                                                      ],
                                                      suffix: _vm.isMeasurementMetric
                                                        ? "kg"
                                                        : "Lbs"
                                                    },
                                                    model: {
                                                      value: props.item.weight,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "weight",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.weight"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "align-center": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass: "mr-3",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "table-item",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              suffix: _vm.isMeasurementMetric
                                                                ? "cm"
                                                                : "in",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "length"
                                                                ),
                                                                _vm.fieldIsOverZero(
                                                                  "length"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .length,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "length",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.length"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass: "mr-3",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "table-item",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              suffix: _vm.isMeasurementMetric
                                                                ? "cm"
                                                                : "in",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "width"
                                                                ),
                                                                _vm.fieldIsOverZero(
                                                                  "width"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .width,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "width",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.width"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs4: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "table-item",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              suffix: _vm.isMeasurementMetric
                                                                ? "cm"
                                                                : "in",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "height"
                                                                ),
                                                                _vm.fieldIsOverZero(
                                                                  "height"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .height,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "height",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.height"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs1: "" } },
                                                        [
                                                          _c(
                                                            "PackagingSelector",
                                                            {
                                                              attrs: {
                                                                packagings:
                                                                  _vm.packagings
                                                              },
                                                              on: {
                                                                select: function(
                                                                  item
                                                                ) {
                                                                  return _vm.onSelectPackaging(
                                                                    item,
                                                                    props.item
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      "hide-details": "",
                                                      disabled: !_vm.enableInsured,
                                                      rules: [
                                                        _vm.fieldIsNoLessThanZero(
                                                          "value"
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        props.item.insuredValue,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "insuredValue",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.insuredValue"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-space-between": "",
                                          "align-baseline": "",
                                          wrap: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { md4: "", xs5: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.shippingServices,
                                                "item-text": "text",
                                                "item-value": "value",
                                                "menu-props": {
                                                  returnValue: "value"
                                                },
                                                label: _vm.$t("shippingService")
                                              },
                                              model: {
                                                value: _vm.shippingService,
                                                callback: function($$v) {
                                                  _vm.shippingService = $$v
                                                },
                                                expression: "shippingService"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md2: "", xs5: "" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                disabled: !_vm.isSupportLabelStockType,
                                                "hide-details": "",
                                                label: _vm.$t("labelStockType"),
                                                items: _vm.labelStockTypes,
                                                "item-text": "text",
                                                "menu-props": {
                                                  returnValue: "value"
                                                }
                                              },
                                              model: {
                                                value: _vm.labelStockType,
                                                callback: function($$v) {
                                                  _vm.labelStockType = $$v
                                                },
                                                expression: "labelStockType"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md2: "", xs5: "" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t(
                                                  "signatureService"
                                                ),
                                                items: _vm.signatureOptions,
                                                "item-text": "text",
                                                "menu-props": {
                                                  returnValue: "value"
                                                }
                                              },
                                              model: {
                                                value: _vm.signature,
                                                callback: function($$v) {
                                                  _vm.signature = $$v
                                                },
                                                expression: "signature"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md2: "", xs5: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("serviceType"),
                                                "item-text": "label",
                                                "item-value": "value",
                                                items: [
                                                  {
                                                    label: _vm.$t("normal"),
                                                    value: false
                                                  },
                                                  {
                                                    label: _vm.$t("expedite"),
                                                    value: true
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.isExpedited,
                                                callback: function($$v) {
                                                  _vm.isExpedited = $$v
                                                },
                                                expression: "isExpedited"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-space-between": "",
                                          wrap: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs5: "" } },
                                          [
                                            _c("SelectWidget", {
                                              attrs: {
                                                label: _vm.$t("otherServices"),
                                                items: _vm.otherServices,
                                                itemText: "displayName",
                                                itemValue: "value",
                                                mutuallyExclusives: [
                                                  "photo",
                                                  "photoForItem"
                                                ],
                                                chipText: "displayName",
                                                displayQty: 3
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedOtherServices,
                                                callback: function($$v) {
                                                  _vm.selectedOtherServices = $$v
                                                },
                                                expression:
                                                  "selectedOtherServices"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs5: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t("memo"),
                                                hint: _vm.$t("memoPrinted", {
                                                  flexibleVars: _vm.flexibleVars.join(
                                                    ", "
                                                  )
                                                }),
                                                rules: [
                                                  _vm.fieldCharLimit("Memo", 40)
                                                ],
                                                counter: "40"
                                              },
                                              model: {
                                                value: _vm.memo,
                                                callback: function($$v) {
                                                  _vm.memo = $$v
                                                },
                                                expression: "memo"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              staticStyle: {
                                                "margin-bottom": "0"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  "instructionTemplate"
                                                ),
                                                items: _vm.instructions,
                                                "item-text": "name",
                                                "return-object": "",
                                                clearable: ""
                                              },
                                              on: {
                                                input: _vm.changeInstruction
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      [
                                        _c("v-textarea", {
                                          staticClass: "thinBox",
                                          attrs: {
                                            label: _vm.$t(
                                              "shipmentInstruction"
                                            ),
                                            outline: "",
                                            rows: "8"
                                          },
                                          model: {
                                            value: _vm.instructionContent,
                                            callback: function($$v) {
                                              _vm.instructionContent = $$v
                                            },
                                            expression: "instructionContent"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isSupportDangerousGoods
                      ? _c(
                          "v-layout",
                          { attrs: { row: "" } },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-card",
                                  { attrs: { width: "100%" } },
                                  [
                                    _c(
                                      "v-card-text",
                                      [
                                        _c("HazardousCommodities", {
                                          attrs: {
                                            dangerousGoods: _vm.dangerousGoods,
                                            offerorName: _vm.offerorName,
                                            emergencyContactNumber:
                                              _vm.emergencyContactNumber,
                                            dryIceWeight:
                                              _vm.dryIceDetail.weight,
                                            dryIceUnit: _vm.dryIceDetail.unit
                                          },
                                          on: {
                                            "update:dangerousGoods": function(
                                              $event
                                            ) {
                                              _vm.dangerousGoods = $event
                                            },
                                            "update:dangerous-goods": function(
                                              $event
                                            ) {
                                              _vm.dangerousGoods = $event
                                            },
                                            "update:offerorName": function(
                                              $event
                                            ) {
                                              _vm.offerorName = $event
                                            },
                                            "update:offeror-name": function(
                                              $event
                                            ) {
                                              _vm.offerorName = $event
                                            },
                                            "update:emergencyContactNumber": function(
                                              $event
                                            ) {
                                              _vm.emergencyContactNumber = $event
                                            },
                                            "update:emergency-contact-number": function(
                                              $event
                                            ) {
                                              _vm.emergencyContactNumber = $event
                                            },
                                            "update:dryIceWeight": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "weight",
                                                $event
                                              )
                                            },
                                            "update:dry-ice-weight": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "weight",
                                                $event
                                              )
                                            },
                                            "update:dryIceUnit": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "unit",
                                                $event
                                              )
                                            },
                                            "update:dry-ice-unit": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "unit",
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.hazMatsInfo,
                                            callback: function($$v) {
                                              _vm.hazMatsInfo = $$v
                                            },
                                            expression: "hazMatsInfo"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        ref: "batchAddSkuFormPopup",
        attrs: {
          title: _vm.$t("batch"),
          rightMethod: _vm.confirmBatchAddSku,
          rightButtonText: _vm.$t("confirm"),
          hasAlert: "",
          medium: ""
        },
        on: { popupClose: _vm.closeBatchAddSkuDialog },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c("v-textarea", {
                              staticClass: "thinBox",
                              attrs: { outline: "", rows: "8" },
                              model: {
                                value: _vm.batchSku,
                                callback: function($$v) {
                                  _vm.batchSku = $$v
                                },
                                expression: "batchSku"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.batchAddSkuDialog,
          callback: function($$v) {
            _vm.batchAddSkuDialog = $$v
          },
          expression: "batchAddSkuDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6595fe24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6595fe24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelTemplatePopup.vue
// module id = null
// module chunks = 